<div
  layout
  layout-align-items-center
  layout-flex-1
  margin-right-small-x
  text-small
  white-space-no-wrap
>
  <ng-content select="[leftSlot]"></ng-content>
</div>

<div layout text-small text-strong min-width-0 layout-align-items-center>
  <ng-content select="[rightSlot]"></ng-content>
</div>
